import React, { FC } from 'react'
import { Button } from '@wmgtech/legato'

import { SearchUser } from 'modules/Users/components'
import { FilterUsers } from 'modulesCommon/Filters/containers'

import styles from './UsersActions.module.scss'

import { UserActionsProps } from './UserActions.props'

const UsersActions: FC<UserActionsProps> = ({ handleSearchUser, loading, onNewUser }) => {

  return (
    <div className={styles.container}>
      <div className={styles.containerFilters}>
        <SearchUser handleSearchUser={handleSearchUser} loading={loading}/>
        <FilterUsers />
      </div>
      <Button
        className="page__margin-left"
        onClick={onNewUser}
        secondaryIcon="circle-plus"
        colorType="secondary-black"
        containerStyle="outline"
        label="New User"
      />
    </div>
  )
}

export default UsersActions
